/* eslint-disable max-len */
import React from 'react';
import Icon from './Icon';

export default Icon(
  <path d="M12.8,6H7.5V0.8C7.5,0.3,7.2,0,6.8,0S6,0.3,6,0.8V6H0.8C0.3,6,0,6.3,0,6.8s0.3,0.8,0.8,0.8H6v5.3c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V7.5h5.3c0.4,0,0.8-0.3,0.8-0.8S13.2,6,12.8,6z" />,
  '0 0 13.5 13.5',
  'PlusIcon',
);
